import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <div className='footer-main'>
      <p className='footer-text'>© Стрельцова Ольга 2024</p>
    </div>
  )
}

export default Footer